import React, { FC, useState } from 'react';
import { useHistory } from 'react-router';
import { Box } from '@chakra-ui/react';

import { useAlert, useApi } from '@app/hooks';
import { useHeader } from '@app/components/common/navigation/hooks/header-service';
import { Paper } from '@app/components/common/paper';

import DistributorForm from './form';

const DistributorCreate: FC = () => {
  useHeader('Новый дистрибьютор', []);
  const history = useHistory();
  const api = useApi();
  const { success } = useAlert();
  const [loading, setLoading] = useState(false);

  return (
    <Box paddingX={{ xs: 0, sm: 2, md: 10, lg: 14, xl: 20 }}>
      <Paper>
        <Box paddingX={4} paddingY={6}>
          <DistributorForm
            loading={loading}
            instance={{}}
            onSubmit={async (payload) => {
              setLoading(true);
              const res = await api.distributors.createDistributor(payload);
              if (!res || res.code !== 200) {
                setLoading(false);
                return;
              }
              setLoading(false);
              success('Дистрибьютор создан');
              history.push('/distributors');
            }}
            onCancel={() => history.push('/distributors')}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default DistributorCreate;
